import { Modal } from "bootstrap"

// Méthode de confirmation de Turbo : affiche #confirm-modal (présente dans le
// layout d'administration) et résout à true si l'utilisateur confirme, false
// s'il ferme la fenêtre. Sans cette fenêtre (site public), confirm() natif.
export function confirmWithModal(message) {
  const modalEl = document.getElementById("confirm-modal")
  if (!modalEl) return Promise.resolve(window.confirm(message))

  return new Promise((resolve) => {
    const modal = Modal.getOrCreateInstance(modalEl)
    const confirmBtn = modalEl.querySelector("[data-confirm-modal-confirm]")
    let confirmed = false

    const onConfirm = () => {
      confirmed = true
      modal.hide()
    }
    confirmBtn.addEventListener("click", onConfirm)
    modalEl.addEventListener("hidden.bs.modal", () => {
      confirmBtn.removeEventListener("click", onConfirm)
      resolve(confirmed)
    }, { once: true })

    modalEl.querySelector("[data-confirm-modal-message]").textContent = message
    modal.show()
  })
}
